"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const AppText_1 = require("../AppText");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const colors_1 = require("../../common/colors");
const react_redux_1 = require("react-redux");
const constants_1 = require("../../common/constants");
const CloseButton_1 = __importDefault(require("../AppButton/CloseButton"));
const AppTooltip_1 = __importDefault(require("../AppTooltip"));
const NotesView = ({ isVisible, onVisibilityChange, onScrollToTop, onSave, preFilledValue, notesType, }) => {
    const selectedFontId = (0, react_redux_1.useSelector)((state) => state.fontSettings.selectedFontId);
    const selectedFont = constants_1.AVAILABLE_FONTS.find(font => font.id === selectedFontId);
    const fontFamily = selectedFont?.fontFamily || 'system font';
    const [isEditing, setIsEditing] = (0, react_1.useState)(false);
    const [isSaveHovered, setIsSaveHovered] = (0, react_1.useState)(false);
    const [noteText, setNoteText] = (0, react_1.useState)('');
    const noteInputRef = (0, react_1.useRef)(null);
    const focusInputRef = (0, react_1.useRef)(null);
    const title = (0, react_1.useMemo)(() => {
        switch (notesType) {
            case 'notes':
                return preFilledValue ? 'Your note' : 'Add a note';
            case 'prompt':
                return isEditing ? 'Edit Prompt' : 'Current Prompt';
            default:
                return '';
        }
    }, [notesType, isEditing, preFilledValue]);
    (0, react_1.useEffect)(() => {
        if (preFilledValue) {
            setNoteText(preFilledValue);
        }
    }, [preFilledValue]);
    // Always focus input when becoming visible
    (0, react_1.useEffect)(() => {
        if (isVisible && notesType === 'notes') {
            setTimeout(() => {
                noteInputRef.current?.focus();
            }, 100);
            onScrollToTop();
        }
    }, [isVisible, onScrollToTop, notesType]);
    // Only change visibility if we're not keeping it visible
    const handleClose = (0, react_1.useCallback)(() => {
        setIsEditing(false);
        if (notesType === 'notes') {
            onVisibilityChange?.(false);
        }
    }, [onVisibilityChange, notesType]);
    const handleFocus = (0, react_1.useCallback)(() => {
        setIsEditing(true);
        onScrollToTop();
    }, [onScrollToTop]);
    const handleSave = (0, react_1.useCallback)(() => {
        onSave(noteText);
        setIsEditing(false);
    }, [onSave, noteText]);
    if (!isVisible)
        return null;
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.noteContainer, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.noteHeader, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.noteTitle, children: title }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.buttonContainer, children: [(notesType === 'notes' || isEditing) && ((0, jsx_runtime_1.jsx)(CloseButton_1.default, { tooltipLabel: notesType === 'notes' ? 'Close Note' : 'Cancel Editing', onClose: handleClose, inPlace: true, verticalOffset: 0, horizontalOffset: 0 })), isEditing && noteText && ((0, jsx_runtime_1.jsx)(AppTooltip_1.default, { label: notesType === 'notes' ? 'Save Note' : 'Update Prompt', isOpen: isSaveHovered, children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: handleSave, onHoverIn: () => setIsSaveHovered(true), onHoverOut: () => setIsSaveHovered(false), style: [
                                        styles.saveButton,
                                        isSaveHovered && styles.saveButtonHover,
                                    ], children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCheck, color: colors_1.Colors.white, size: 16 }) }) }))] })] }), (0, jsx_runtime_1.jsx)(react_native_1.TextInput, { ref: noteInputRef, style: [styles.notesTextArea, { outline: 'unset', fontFamily: fontFamily }], multiline: true, value: noteText, onChangeText: setNoteText, autoFocus: false, editable: isEditing, onFocus: handleFocus, selection: { start: noteText.length, end: noteText.length } }), (0, jsx_runtime_1.jsx)(react_native_1.TextInput, { ref: focusInputRef, style: styles.focusInput })] }));
};
const styles = react_native_1.StyleSheet.create({
    noteContainer: {
        backgroundColor: colors_1.Colors.DARK_600,
        borderColor: colors_1.Colors.DARK_400,
        borderRadius: 8,
        borderWidth: 1,
        padding: 16,
    },
    noteHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 16,
    },
    noteTitle: {
        color: colors_1.Colors.white,
        fontSize: 18,
        fontWeight: '600',
    },
    buttonContainer: {
        flexDirection: 'row',
        gap: 8,
    },
    saveButton: {
        backgroundImage: `linear-gradient(180deg, ${colors_1.Colors.GRADIENT[0]}, ${colors_1.Colors.GRADIENT[1]})`,
        borderRadius: 32,
        padding: 8,
    },
    saveButtonHover: {
        backgroundImage: `linear-gradient(210deg, ${colors_1.Colors.GRADIENT[0]}, ${colors_1.Colors.GRADIENT[1]})`,
        opacity: 0.95,
    },
    notesTextArea: {
        backgroundColor: colors_1.Colors.DARK_600,
        minHeight: 100,
        color: colors_1.Colors.white,
        marginBottom: 16,
    },
    focusInput: {
        width: 0,
        height: 0,
    }
});
exports.default = NotesView;
